import React from 'react';
import { LoadScript } from '@react-google-maps/api';

interface GoogleMapsProviderProps {
  children: React.ReactNode;
}

const libraries: ("places" | "geometry" | "drawing" | "visualization" | "routes")[] = ["places", "routes"];

export const GoogleMapsProvider: React.FC<GoogleMapsProviderProps> = ({ children }) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

  if (!apiKey) {
    console.error('❌ Google Maps API key not found in environment variables');
    console.error('Expected: REACT_APP_GOOGLE_MAPS_API_KEY in .env.local');
    return <>{children}</>;
  }


  return (
    <LoadScript
      googleMapsApiKey={apiKey}
      libraries={libraries}
      version="weekly"
      onLoad={() => { /* Maps loaded */ }}
      onError={(error) => {
        console.error('❌ Google Maps failed to load:', error);
        console.error('Please check:');
        console.error('1. API key is valid');
        console.error('2. Billing is enabled in Google Cloud Console');
        console.error('3. Maps JavaScript API is enabled');
        console.error('4. No domain restrictions preventing localhost');
      }}
    >
      {children}
    </LoadScript>
  );
};

export default GoogleMapsProvider;
